import { Modal } from "react-bootstrap";

const ConfirmationModal = ({
  show,
  onHide,
  modalTitle,
  modalText,
  handleSubmit,
  submitText,
}) => {
  const onCloseModal = () => {
    onHide();
  };

  return (
    <Modal
      show={show}
      onHide={onCloseModal}
      className="confirmation_modal"
      backdrop="static"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          {modalTitle}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>{modalText}</Modal.Body>
      <Modal.Footer>
        <button className="close_btn" onClick={onCloseModal}>
          Close
        </button>
        <button className="submit_btn" onClick={handleSubmit}>
          {submitText}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmationModal;
